/**
 * PrintableSanitizer — desktop port of BigxBookApp/src/printing/engine/PrintableSanitizer.ts.
 * ESC/POS firmware on most low-cost thermal printers cannot render glyphs
 * outside CP437/ASCII; we replace common Unicode characters with safe
 * ASCII equivalents and strip the rest.
 */

const REPLACEMENTS: Record<string, string> = {
  '\u20B9': 'Rs.', // ₹
  '\u2013': '-',
  '\u2014': '-',
  '\u2018': "'",
  '\u2019': "'",
  '\u201c': '"',
  '\u201d': '"',
};

export const sanitizeForAscii = (value: string): string => {
  let out = value;
  Object.entries(REPLACEMENTS).forEach(([from, to]) => {
    out = out.split(from).join(to);
  });

  // Strip remaining non-ASCII bytes to keep most thermal printers happy.
  return out.replace(/[^\x20-\x7E\n\r\t]/g, '?');
};
